<div class="page-container">
  <div class="page-content-wrapper page-full-width">
    <div class="page-content" style="background-color: #f0f4f7">
      <!-- Page header -->
      <div class="row">
        <div class="col-md-12">
          <h1 class="page-title button-center">
            <!-- TODO add translations -->
            <span>Hey, {{ staffName }}! Manage Your Account</span>
            <br>
            <small><span>Manage your personal & business settings</span></small>
          </h1>
          <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-10"></div>
            <div class="col-md-1"></div>
          </div>
        </div>
      </div>
      <div class="row margin-bottom-20">
        <div class="col-md-12">
          <div class="portlet light">
            <div>
              <tabset [justified]="true">
                <tab #tabgroup style="background-color: white;">
                  <span *tabHeading>
                    <mat-icon>settings</mat-icon><br> <small>Account Settings</small>
                  </span>
                  <app-account-settings></app-account-settings>
                </tab>
                <tab #tabgroup>
                  <span *tabHeading>
                    <mat-icon>shopping_cart</mat-icon><br> <small>Change Plans</small>
                  </span>
                  <app-change-plans></app-change-plans>
                </tab>
                <tab #tabgroup>
                  <span *tabHeading>
                    <mat-icon>credit_card</mat-icon><br> <small>Billing Info</small>
                  </span>
                  <app-billing-information></app-billing-information>
                </tab>
                <tab #tabgroup>
                  <span *tabHeading>
                    <mat-icon>bedtime</mat-icon><br> <small>Hibernate/Cancel Account</small>
                  </span>
                  <app-hibernate-cancel></app-hibernate-cancel>
                </tab>

              </tabset>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
